import React from "react";
import { FEATURE_FLAGS, useFeatureFlag } from "~/config/ff";
import MyDashboard from "../MyDashboard/MyDashboard";
import GlobalEntitiesList from "~/components/global-entities/GlobalEntities";
const LandingPage = () => {
  const { value: isMyDashboardFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.MY_DASHBOARD,
    false,
  );

  return isMyDashboardFeatureEnabled ? <MyDashboard /> : <GlobalEntitiesList />;
};

export default LandingPage;
